import classNames from 'classnames'
import { useEffect, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { MODE_MAPPER } from '../helper'

import style from './ModeFilter.module.scss'

export const ModeFilter = () => {
    const navi = useNavigate()
    const location = useLocation()

    const pathElems = location.pathname.split('/').filter((el) => el.length > 1)

    const isChosenDirectory = pathElems.length > 1

    const variants = useMemo(
        () => [
            {
                title: MODE_MAPPER.insureds,
                mode: 'insureds',
                callback: () => navi('insureds')
            },
            {
                title: MODE_MAPPER.companies,
                mode: 'companies',
                callback: () => navi('companies')
            }
        ],
        [navi]
    )

    useEffect(() => {
        if (!isChosenDirectory) {
            variants[0].callback()
        }
    }, [isChosenDirectory, variants])

    return (
        <div className={style.container}>
            {variants.map((varint) => {
                const { title, mode, callback } = varint
                const isChosen = location.pathname.includes(mode)
                return (
                    <div key={title} className={classNames(style.btn, isChosen && style.btnChosen)} onClick={callback}>
                        {title}
                    </div>
                )
            })}
        </div>
    )
}
